import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  FaTimes,
  FaPlug,
  FaMagic,
  FaLock,
  FaGlobe,
  FaKey,
  FaClock,
  FaSlidersH,
  FaExchangeAlt,
  FaDatabase,
} from 'react-icons/fa';
import Select from 'react-select';
import { SELECT_ESTATUS_SERVICE } from '../../interfaces/services.interface';
import { interoperabilityApi } from '../../api/interoperability.api';
import { MODE } from '../../../../interaces/mode.interface';
import { conectorInteroperabilitySchema } from '../../schemas/service.schema';
import { Controller } from 'react-hook-form';
import {
  ENUM_METHOD_SERVICE,
  ENUM_AUTH_TYPE,
  ENUM_STATUS_SERVICE,
  ENUM_PROTOCOL_TYPE_SERVICE,
} from '../../interfaces/services.interface';
import { TABS_SERVICES, ENUM_TABS_SERVICES } from '../../interfaces/services.interface';
import { SELECT_PROTOCOL_TYPE, SELECT_METHOD_SERVICE } from '../../interfaces/services.interface';
import styles from '../../styles/styles.module.css';
const PRESETS = {
  SEP_DGAIR: {
    name: 'SEP - DGAIR Cédulas y Títulos',
    institution: 'Secretaría de Educación Pública (Federal)',
    version: 'v2.1',
    method: ENUM_METHOD_SERVICE.POST,
    protocolType: ENUM_PROTOCOL_TYPE_SERVICE.REST,
    authType: ENUM_AUTH_TYPE.BEARER,
    endpointUrl: 'https://api.sep.gob.mx/dgair/v2/titulos/consulta',
    timeoutMs: 6000,
    request: {
      curp: 'PEGA900101HDFRRN09',
      matricula: '2020-SEP-99418',
    },
    response: {
      matricula: '2020-SEP-99418',
      curp: 'PEGA900101HDFRRN09',
      nombre: 'ALEJANDRO',
      primerApellido: 'PÉREZ',
      segundoApellido: 'GÓMEZ',
      institucion: {
        claveCCT: '22MSU0010Z',
        nombreInstitucion: 'UNIVERSIDAD AUTÓNOMA DE QUERÉTARO',
        entidad: 'QUERÉTARO',
      },
      carrera: {
        claveCarrera: '611300001',
        nombreCarrera: 'LICENCIATURA EN INFORMÁTICA',
        nivelEducativo: 'LICENCIATURA',
      },
      titulacion: {
        fechaExpedicion: '2024-09-01',
        numeroCedula: '12847592',
        promedio: 9.64,
      },
      estatus: 'VALIDADO_Y_REGISTRADO',
    },
  },

  REGISTRO_CIVIL: {
    name: 'Registro Civil del Estado de Querétaro',
    institution: 'Gobierno del Estado de Querétaro',
    version: 'v3.0',
    method: ENUM_METHOD_SERVICE.POST,
    protocolType: ENUM_PROTOCOL_TYPE_SERVICE.REST,
    authType: ENUM_AUTH_TYPE.API_KEY_HEADER,
    endpointUrl: 'https://registrocivil.queretaro.gob.mx/api/v3/actas/nacimiento',
    timeoutMs: 5000,
    request: {
      curp: 'GARM950315MQRNLL04',
      anioRegistro: 1995,
    },
    response: {
      curp: 'GARM950315MQRNLL04',
      datosPersona: {
        nombre: 'MARÍA FERNANDA',
        primerApellido: 'GARCÍA',
        segundoApellido: 'RAMÍREZ',
        fechaNacimiento: '1995-03-15',
        sexo: 'MUJER',
      },
      acta: {
        numeroActa: '01428',
        anioRegistro: 1995,
        libro: '02',
        foja: '142',
        oficialia: 'OFICIALIA 01 CENTRO',
        municipio: 'QUERÉTARO',
      },
      estatus: 'VIGENTE',
    },
  },

  RENAPO: {
    name: 'RENAPO - Consulta y Validación CURP',
    institution: 'Gobierno Federal (SEGOB)',
    version: 'v2.0',
    method: ENUM_METHOD_SERVICE.POST,
    protocolType: ENUM_PROTOCOL_TYPE_SERVICE.REST,
    authType: ENUM_AUTH_TYPE.NONE,
    endpointUrl: 'https://renapo.gob.mx/ws/curp/consulta',
    timeoutMs: 5000,
    request: {
      curp: 'PEGA900101HDFRRN09',
    },
    response: {
      curp: 'PEGA900101HDFRRN09',
      nombres: 'ALEJANDRO',
      primerApellido: 'PÉREZ',
      segundoApellido: 'GÓMEZ',
      fechaNacimiento: '1990-01-01',
      sexo: 'HOMBRE',
      statusCurp: 'ANOTACION_DE_CUMPLE',
    },
  },

  SAT: {
    name: 'SAT - Constancia de Situación Fiscal',
    institution: 'Gobierno Federal (SHCP / SAT)',
    version: 'v1.4',
    method: ENUM_METHOD_SERVICE.POST,
    protocolType: ENUM_PROTOCOL_TYPE_SERVICE.REST,
    authType: ENUM_AUTH_TYPE.BEARER,
    endpointUrl: 'https://sat.gob.mx/api/v1/opinion-cumplimiento',
    timeoutMs: 6000,
    request: {
      rfc: 'PEGA900101AAA',
    },
    response: {
      rfc: 'PEGA900101AAA',
      razonSocial: 'ALEJANDRO PÉREZ GÓMEZ',
      regimenFiscal: '605 - Sueldos y Salarios',
      estatusFiscal: 'ACTIVO',
      opinionCumplimiento: 'POSITIVA',
    },
  },

  CATASTRO: {
    name: 'Dirección Estatal de Catastro',
    institution: 'Gobierno Estatal',
    version: 'v1.8',
    method: ENUM_METHOD_SERVICE.POST,
    protocolType: ENUM_PROTOCOL_TYPE_SERVICE.SOAP,
    authType: ENUM_AUTH_TYPE.BASIC,
    endpointUrl: 'https://catastro.queretaro.gob.mx/ws/predial',
    soapAction: 'ConsultarClaveCatastral',
    timeoutMs: 8000,
    request: {
      claveCatastral: '140100101001001',
      municipio: 'Querétaro',
    },
    response: {
      claveCatastral: '140100101001001',
      propietario: 'ALEJANDRO PÉREZ GÓMEZ',
      direccionInmueble: 'AV. CONSTITUYENTES 102, COL. CENTRO',
      superficieTerreno: 250.5,
      valorCatastral: 1850000.0,
      estatusPredial: 'AL_CORRIENTE',
    },
  },

  RPPYC: {
    name: 'Registro Público de la Propiedad (RPPyC)',
    institution: 'Gobierno del Estado de Querétaro',
    version: 'v3.2',
    method: ENUM_METHOD_SERVICE.GET,
    protocolType: ENUM_PROTOCOL_TYPE_SERVICE.REST,
    authType: ENUM_AUTH_TYPE.API_KEY_HEADER,
    endpointUrl: 'https://rppyc.queretaro.gob.mx/api/folios/consultar',
    timeoutMs: 5000,
    request: {
      folioReal: 'RP-998241-QRO',
    },
    response: {
      folioReal: 'RP-998241-QRO',
      titular: 'ALEJANDRO PÉREZ GÓMEZ',
      gravamen: false,
      estatus: 'REGISTRADO',
    },
  },
};

const EMPTY_FORM = {
  code: '',
  name: '',
  institution: 'Gobierno Estatal',
  version: 'v1.0',
  status: ENUM_STATUS_SERVICE.CONNECTED,
  method: ENUM_METHOD_SERVICE.POST,
  protocolType: ENUM_PROTOCOL_TYPE_SERVICE.REST,
  authType: ENUM_AUTH_TYPE.NONE,
  authToken: '',
  authUser: '',
  authPasswordRaw: '',
  endpointUrl: '',
  soapAction: '',
  timeoutMs: 5000,
  headersStr: '{\n  "Accept": "application/json"\n}',
  queryParamsStr: '{}',
  requestStr: '{\n  "parametro": "ejemplo"\n}',
  responseStr: '{\n  "estatus": "OK",\n  "mensaje": "Respuesta estructurada de prueba"\n}',
};

function Field({ label, children, hint }) {
  return (
    <div className={styles.fielDiv}>
      <label className={styles.fieldLabel}>{label}</label>

      {children}
      {hint && <span className={styles.fieldSpan}>{hint}</span>}
    </div>
  );
}

function ErrorMessage({ error }) {
  if (!error) return null;

  return <span className="error-text">{error.message}</span>;
}

function ModalConfigurationConector({ onClose, mode = MODE.CREATE, model = null, setEntities }) {
  const {
    register,
    watch,
    setValue,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
    control,
  } = useForm({
    resolver: zodResolver(conectorInteroperabilitySchema),
    defaultValues: EMPTY_FORM,
  });

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [activeSubTab, setActiveSubTab] = useState(ENUM_TABS_SERVICES.GENERAL);

  const protocolType = watch('protocolType');
  const authType = watch('authType');

  useEffect(() => {
    if (model && mode === MODE.UPDATE) {
      reset({
        code: model.code || model.name || '',
        name: model.name || '',
        institution: model.institution || 'Gobierno Estatal',
        version: model.version || 'v1.0',
        status: model.status || ENUM_STATUS_SERVICE.CONNECTED,
        method: model.method || ENUM_METHOD_SERVICE.POST,
        protocolType: model.protocolType || ENUM_PROTOCOL_TYPE_SERVICE.REST,
        authType: model.authType || ENUM_AUTH_TYPE.NONE,
        authToken: model.authToken || '',
        authUser: model.authUser || '',
        authPasswordRaw: '',
        endpointUrl: model.endpointUrl || '',
        soapAction: model.soapAction || '',
        timeoutMs: model.timeoutMs || 5000,
        headersStr: JSON.stringify(model.headers || { Accept: 'application/json' }, null, 2),
        queryParamsStr: JSON.stringify(model.queryParams || {}, null, 2),
        requestStr: JSON.stringify(model.request || {}, null, 2),
        responseStr: JSON.stringify(model.response || {}, null, 2),
      });
    } else {
      reset(EMPTY_FORM);
    }

    setError('');
    setActiveSubTab(ENUM_TABS_SERVICES.GENERAL);
  }, [model, mode, reset]);

  const applyPreset = (key) => {
    const preset = PRESETS[key];

    if (!preset) return;

    const values = {
      code: key,
      name: preset.name,
      institution: preset.institution,
      version: preset.version,
      method: preset.method,
      protocolType: preset.protocolType || ENUM_PROTOCOL_TYPE_SERVICE.REST,
      authType: preset.authType || ENUM_AUTH_TYPE.NONE,
      endpointUrl: preset.endpointUrl || '',
      soapAction: preset.soapAction || '',
      timeoutMs: preset.timeoutMs || 5000,
      requestStr: JSON.stringify(preset.request || {}, null, 2),
      responseStr: JSON.stringify(preset.response || {}, null, 2),
    };

    Object.entries(values).forEach(([field, value]) => {
      setValue(field, value, {
        shouldDirty: true,
        shouldValidate: true,
      });
    });
  };

  const onSubmit = async (data) => {
    setSaving(true);
    try {
      const payload = {
        code: data.code || data.name,
        name: data.name.trim(),
        institution: data.institution,
        version: data.version,
        status: data.status,
        method: data.method,
        protocolType: data.protocolType,
        authType: data.authType,

        authToken: data.authToken || null,
        authUser: data.authUser || null,
        authPasswordRaw: data.authPasswordRaw || null,

        endpointUrl: data.endpointUrl || null,
        soapAction: data.soapAction || null,

        timeoutMs: data.timeoutMs,

        headers: JSON.parse(data.headersStr),
        queryParams: JSON.parse(data.queryParamsStr),
        request: JSON.parse(data.requestStr),
        response: JSON.parse(data.responseStr),
      };

      const response = await interoperabilityApi.saveService(payload);

      setEntities((prev) => [response, ...prev]);

      onClose();
    } catch (err) {
      setError('Error al guardar conector: ' + (err.message || 'Error desconocido'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content  modal-sizes">
        <div className="modal-header">
          <div>
            <h2 className="modal-title">
              <FaPlug className="text-primary" />
              {model ? 'Configurar Conector de Dependencia' : 'Nuevo Conector de Interoperabilidad'}
            </h2>
            <span className="modal-description">
              Conexión bidireccional con dependencias gubernamentales mediante Apache Camel y Spring
              Integration
            </span>
          </div>
          <button type="button" className="modal-close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className={styles.tab}>
          {TABS_SERVICES.map((tab) => (
            <button
              key={tab.enum}
              type="button"
              onClick={() => setActiveSubTab(tab.enum)}
              className={`tab-item ${activeSubTab === tab.enum ? 'tab-item-active' : ''}`}
            >
              {tab.icon} {tab.id}
            </button>
          ))}
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className={styles.modalForm}>
          {error && <div className={styles.error}>{error}</div>}

          {!model && (
            <div className={styles.presetContainer}>
              <div className={styles.presetHeader}>
                <div className={styles.presetTitle}>
                  <FaMagic className={styles.presetIcon} />
                  Plantillas de Conectores Oficiales:
                </div>

                <span className={styles.presetDescription}>
                  Selecciona para auto-rellenar la configuración
                </span>
              </div>

              <div className={styles.presetList}>
                {Object.keys(PRESETS).map((key) => (
                  <button
                    key={key}
                    type="button"
                    onClick={() => applyPreset(key)}
                    className={styles.presetButton}
                  >
                    + {key}
                  </button>
                ))}
              </div>
            </div>
          )}

          {activeSubTab === ENUM_TABS_SERVICES.GENERAL && (
            <div className={styles.formSection}>
              <div className={styles.twoColumnGrid}>
                <Field label="Nombre del Conector *">
                  <input
                    type="text"
                    placeholder="Ej: SEP - Dirección General de Acreditación"
                    {...register('name')}
                    className={styles.formInput}
                  />
                  <ErrorMessage error={errors.name} />
                </Field>

                <Field label="Institución / Dependencia">
                  <input
                    type="text"
                    placeholder="Ej: Secretaría de Educación Pública"
                    {...register('institution')}
                    className={styles.formInput}
                  />
                  <ErrorMessage error={errors.institution} />
                </Field>
              </div>

              <div className={styles.fourColumnGrid}>
                <Field label="Versión">
                  <input
                    type="text"
                    placeholder="v1.0"
                    {...register('version')}
                    className={styles.formInput}
                  />
                  <ErrorMessage error={errors.version} />
                </Field>

                <Field label="Protocolo">
                  <Controller
                    name="protocolType"
                    control={control}
                    render={({ field }) => (
                      <Select
                        options={SELECT_PROTOCOL_TYPE}
                        getOptionLabel={(option) => option.value}
                        getOptionValue={(option) => option.key}
                        value={
                          SELECT_PROTOCOL_TYPE.find((option) => option.key === field.value) || null
                        }
                        onChange={(option) => field.onChange(option?.key ?? '')}
                        placeholder="Todos los Protocolos"
                        isSearchable={false}
                      />
                    )}
                  />
                  {errors.protocolType && (
                    <span className="error-text">{errors.protocolType.message}</span>
                  )}
                </Field>

                <Field label="Método">
                  <Controller
                    name="method"
                    control={control}
                    render={({ field }) => (
                      <Select
                        options={SELECT_METHOD_SERVICE}
                        getOptionLabel={(option) => option.value}
                        getOptionValue={(option) => option.key}
                        value={
                          SELECT_METHOD_SERVICE.find((option) => option.key === field.value) || null
                        }
                        onChange={(option) => field.onChange(option?.key ?? '')}
                        placeholder="Todos los métodos"
                        isSearchable={false}
                      />
                    )}
                  />
                  {errors.method && <span className="error-text">{errors.method.message}</span>}
                </Field>

                <Field label="Estado">
                  <Controller
                    name="status"
                    control={control}
                    render={({ field }) => (
                      <Select
                        options={SELECT_ESTATUS_SERVICE}
                        getOptionLabel={(option) => option.key}
                        getOptionValue={(option) => option.key}
                        value={
                          SELECT_ESTATUS_SERVICE.find((option) => option.value === field.value) ||
                          null
                        }
                        onChange={(option) => field.onChange(option?.value)}
                        placeholder="Todos los Estatus"
                        isSearchable={false}
                      />
                    )}
                  />
                  {errors.status && <span className="error-text">{errors.status.message}</span>}
                </Field>
              </div>

              <div className={styles.endpointGrid}>
                <div className={styles.endpointField}>
                  <Field
                    label={
                      <>
                        <FaGlobe className={styles.fieldIcon} />
                        URL del Servicio Remoto
                      </>
                    }
                    hint="Dejar en blanco si se usará el motor simulador offline"
                  >
                    <input
                      type="url"
                      placeholder="https://api.dependencia.gob.mx/endpoint/consulta"
                      {...register('endpointUrl')}
                      className={styles.formInput}
                    />
                    <ErrorMessage error={errors.endpointUrl} />
                  </Field>
                </div>

                <Field
                  label={
                    <>
                      <FaClock className={styles.fieldIcon} />
                      Timeout (ms)
                    </>
                  }
                >
                  <input
                    type="number"
                    min="1000"
                    step="500"
                    {...register('timeoutMs', { valueAsNumber: true })}
                    className={styles.formInput}
                  />
                  <ErrorMessage error={errors.timeoutMs} />
                </Field>
              </div>

              {protocolType === ENUM_PROTOCOL_TYPE_SERVICE.SOAP && (
                <Field label="SOAP Action">
                  <input
                    type="text"
                    placeholder="Ej: http://tempuri.org/ConsultarCertificado"
                    {...register('soapAction')}
                    className={styles.formInput}
                  />
                  <ErrorMessage error={errors.soapAction} />
                </Field>
              )}
            </div>
          )}

          {activeSubTab === ENUM_TABS_SERVICES.AUTH && (
            <div className={styles.formSection}>
              <div className={styles.twoColumnGrid}>
                <Field
                  label={
                    <>
                      <FaLock className={styles.fieldIcon} />
                      Esquema de Autenticación
                    </>
                  }
                >
                  <select {...register('authType')} className={styles.formSelect}>
                    <option value="NONE">Sin autenticación requerida</option>
                    <option value="BEARER">Bearer Token (JWT / OAuth)</option>
                    <option value="API_KEY_HEADER">API Key en Encabezado (X-API-Key)</option>
                    <option value="API_KEY_QUERY">API Key en Parámetro Query (?api_key=)</option>
                    <option value="BASIC">Basic Auth (Usuario y Contraseña)</option>
                  </select>
                  <ErrorMessage error={errors.authType} />
                </Field>

                {(authType === ENUM_AUTH_TYPE.BEARER ||
                  authType === ENUM_AUTH_TYPE.API_KEY_HEADER ||
                  authType === ENUM_AUTH_TYPE.API_KEY_QUERY) && (
                  <Field
                    label={
                      <>
                        <FaKey className={styles.fieldIcon} />
                        Token / Llave Secreta
                      </>
                    }
                  >
                    <input
                      type="password"
                      placeholder="eyJhbGciOi... o Llave de API"
                      {...register('authToken')}
                      className={styles.formInput}
                    />
                    <ErrorMessage error={errors.authToken} />
                  </Field>
                )}
              </div>

              {(authType === ENUM_AUTH_TYPE.BASIC ||
                protocolType === ENUM_PROTOCOL_TYPE_SERVICE.SOAP) && (
                <div className={styles.twoColumnGrid}>
                  <Field label="Usuario de Acceso">
                    <input
                      type="text"
                      placeholder="usuario_servicio"
                      {...register('authUser')}
                      className={styles.formInput}
                    />
                    <ErrorMessage error={errors.authUser} />
                  </Field>

                  <Field label="Contraseña">
                    <input
                      type="password"
                      placeholder={
                        model ? '(Dejar vacío para conservar actual)' : 'Contraseña de servicio'
                      }
                      {...register('authPasswordRaw')}
                      className={styles.formInput}
                    />
                    <ErrorMessage error={errors.authPasswordRaw} />
                  </Field>
                </div>
              )}

              <div className={styles.twoColumnGrid}>
                <Field
                  label={
                    <>
                      <FaSlidersH className={styles.fieldIcon} />
                      Encabezados HTTP (JSON)
                    </>
                  }
                  hint="Headers adicionales enviados con cada petición"
                >
                  <textarea rows={4} {...register('headersStr')} className={styles.formTextarea} />
                  <ErrorMessage error={errors.headersStr} />
                </Field>

                <Field
                  label={
                    <>
                      <FaSlidersH className={styles.fieldIcon} />
                      Parámetros Query URL (JSON)
                    </>
                  }
                  hint="Parámetros añadidos a la URL de consulta"
                >
                  <textarea
                    rows={4}
                    {...register('queryParamsStr')}
                    className={styles.formTextarea}
                  />
                  <ErrorMessage error={errors.queryParamsStr} />
                </Field>
              </div>
            </div>
          )}

          {activeSubTab === ENUM_TABS_SERVICES.SCHEMAS && (
            <div className={styles.formSection}>
              <Field
                label={
                  <>
                    <FaExchangeAlt className={styles.fieldIcon} />
                    Esquema de Petición (Payload de Entrada)
                  </>
                }
                hint="Estructura de datos o parámetros requeridos para la consulta"
              >
                <textarea rows={5} {...register('requestStr')} className={styles.formTextarea} />
                <ErrorMessage error={errors.requestStr} />
              </Field>

              <Field
                label={
                  <>
                    <FaDatabase className={styles.fieldIcon} />
                    Esquema de Respuesta de la Colección
                  </>
                }
                hint="Respuesta de ejemplo que se utilizará para introspección y filtrado de campos para XSD"
              >
                <textarea rows={8} {...register('responseStr')} className={styles.formTextarea} />
                <ErrorMessage error={errors.responseStr} />
              </Field>
            </div>
          )}

          <div
            className={`modal-footer  ${styles.formFooter}`}
          >
            <button type="button" onClick={onClose} className="btn-cancel">
              Cancelar
            </button>

            <button
              type="submit"
              disabled={saving || (mode === MODE.UPDATE && !isDirty)}
              className="btn-primary"
            >
              {saving ? 'Guardando...' : mode === MODE.CREATE ? 'Agregar' : 'Actualizar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModalConfigurationConector;
